import React from "react";
import {Form} from "react-bootstrap";

function STCFormFloatingLabel(props){
    return(
        <Form.FloatingLabel
            style={props.style}
            className={props.className}

            ref={props.ref}
            as={props.as}
            column={props.column}
            htmlFor={props.htmlFor}
            visuallyhidden={props.visuallyhidden}
            bsPrefix={props.bsPrefix}
            size={props.size}
            label={props.label}

            sm={props.sm}
        >
            {props.children}
        </Form.FloatingLabel>
    )
}
export default STCFormFloatingLabel;